import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_DESIGN_PATH_KEY } from '@/swagger/constants/slash-keys';
import { API_GET_ASPECT_CALL, KEY_GET_ASPECT_FOR_APP } from '../constants';
import { MOCK_RESPONSE_GET_ASPECT_FOR_APP } from '../mocks';

type ResponseGetAspectForApp = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_DESIGN_PATH_KEY
>['response']['body'];

type CallParamsGetAspectForApp = {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseGetAspectForApp = ResponseGetAspectForApp;

type CallErrorGetAspectForApp = GenericApiError;

type CallSelectorsGetAspectForApp = {
  totalDesignQuota: number;
  remainingDesignQuota: number;
};

export const getAspectForAppCall = createGeneralCall<
  CallParamsGetAspectForApp,
  CallResponseGetAspectForApp,
  CallErrorGetAspectForApp,
  CallSelectorsGetAspectForApp
>({
  id: KEY_GET_ASPECT_FOR_APP,
  method: 'get',
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_GET_ASPECT_CALL(org);
  },
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_GET_ASPECT_FOR_APP
    : undefined,
  selectors: {
    totalDesignQuota: ({ selectors }) =>
      createSelector(selectors.response, res => res?.aiDesignQuota?.total || 0),
    remainingDesignQuota: ({ selectors }) =>
      createSelector(selectors.response, res => res?.aiDesignQuota?.remaining || 0),
  },
});
